import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
} from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import Notification, { showToast,}  from "../../../components/common/notification/Notification";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const EditHelpCenterItem = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const { Id } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = loggedInUser?.refreshToken;
  const navigate = useNavigate();

  const [contactUs, setContactUs] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Help Center", link: "/help-center" },
    { label: Id, link: "", active: true },
  ];

  useEffect(() => {
    fetchHelpCenterItem();
  }, []);

  const fetchHelpCenterItem = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/admin/contactus/${Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setContactUs(response.data.contactUs);
      }
    } catch (error) {
      console.error(error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email_address: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    message: Yup.string().required("Message is required"),
    mobile_number: Yup.string()
      .matches(/^[0-9]+$/, "Mobile number must be digits")
      .min(10, "Mobile number must be at least 10 digits")
      .max(10, "Mobile number must not exceed 10 digits")
      .required("Mobile number is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await axios.put(
        `${baseUrl}/admin/editContactUs`,
        { ...values, id: Id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        showToast("Inquiry details updated successfully", { type: "success" });
        setTimeout(() => {
          navigate("/help-center");
        }, 3000);
      }
    } catch (error) {
      console.error("Update error:", error);
      showToast("Error Occurred", { type: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />

        <Row>
          <Col lg={9} md={8} sm={12}>
            <SingleDetailHeader
              header="Edit Help Center Item"
              description="Edit the inquiry details below"
            />
          </Col>
        </Row>

        <Row className="my-3 justify-content-center">
          <Col lg={9} md={8} sm={12}>

            {contactUs && (
              <Formik
                initialValues={{
                  name: contactUs.name || "",
                  email_address: contactUs.email_address || "",
                  message: contactUs.message || "",
                  mobile_number: contactUs.mobile_number || "",
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <FormikForm>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Name</Form.Label>
                      <Field
                        name="name"
                        className="form-control"
                        placeholder="Enter name"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="name" />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Email</Form.Label>
                      <Field
                        name="email_address"
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="email_address" />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Mobile Number</Form.Label>
                      <Field
                        name="mobile_number"
                        type="number"
                        className="form-control"
                        placeholder="Enter mobile number"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="mobile_number" />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Message</Form.Label>
                      <Field
                        name="message"
                        as="textarea"
                        className="form-control"
                        placeholder="Enter message"
                        rows={4}
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="message" />
                      </div>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </Button>
                    <Link className="btn btn-secondary mx-4" to="/help-center">
                      Back
                    </Link>
                  </FormikForm>
                )}
              </Formik>
            )}

            
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditHelpCenterItem;
